import {
  createEntityAdapter,
  createSlice,
  EntityId,
  PayloadAction,
} from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { Message } from "./messagesAPI";

const messagesAdapter = createEntityAdapter<Message>();

interface InitialState
  extends ReturnType<typeof messagesAdapter.getInitialState> {
  timeLastSentMessage?: string;
  status: "fulfilled" | "pending" | "rejected";
}
const initialState: InitialState = {
  ...messagesAdapter.getInitialState(),
  status: "fulfilled",
};

const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    timeStampLastSentMessage(state) {
      state.timeLastSentMessage = new Date().toISOString();
    },
    setStatus(state, action: PayloadAction<InitialState["status"]>) {
      state.status = action.payload;
    },
    setMessages(state, action: PayloadAction<Message[]>) {
      messagesAdapter.removeAll(state);
      messagesAdapter.addMany(state, action.payload);
    },
    removeMessage(state, action: PayloadAction<EntityId>) {
      // console.log("removing message");
      messagesAdapter.removeOne(state, action.payload);
    },
  },
});

export const messagesSelectors = messagesAdapter.getSelectors(
  (state: RootState) => state.messages
);

export const selectTimeLastSentMessage = (state: RootState) =>
  state.messages.timeLastSentMessage;

export const selectMessagesStatus = (state: RootState) => state.messages.status;

export const messagesReducer = messagesSlice.reducer;
export const messagesActions = messagesSlice.actions;
